import { useState } from 'react';
import { Outlet, NavLink, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/backoffice.css';

export default function BackOfficeLayout() {
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMenu = () => setMobileMenuOpen(false);

  const navLinks = [
    { to: '/backoffice', label: 'Overview', end: true },
    { to: '/backoffice/accounts', label: 'Accounts' },
    { to: '/backoffice/engagement', label: 'Engagement' },
    { to: '/backoffice/content', label: 'Content' },
    { to: '/backoffice/rewards', label: 'Rewards' },
    { to: '/backoffice/trends', label: 'Trends' },
  ];

  return (
    <div className="bo-layout">
      <header className="bo-header">
        <NavLink to="/backoffice" className="bo-header-brand" end>
          CrewCast
          <span className="bo-header-badge">Back Office</span>
        </NavLink>

        <nav className="bo-header-nav bo-desktop-nav">
          {navLinks.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `bo-nav-link${isActive ? ' active' : ''}`}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="bo-header-user bo-desktop-nav">
          {user?.email && <span className="bo-header-email">{user.email}</span>}
          <Link to="/dashboard" className="bo-logout-btn">
            Normal View
          </Link>
          <button className="bo-logout-btn" onClick={logout}>
            Log out
          </button>
        </div>

        <button
          className="bo-mobile-menu-btn"
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={22} />
        </button>
      </header>

      {mobileMenuOpen && (
        <>
          <div className="bo-mobile-overlay" onClick={closeMenu} />
          <div className="bo-mobile-sheet">
            <div className="bo-mobile-sheet-header">
              <span className="bo-mobile-sheet-title">Back Office</span>
              <button className="bo-mobile-sheet-close" onClick={closeMenu} aria-label="Close menu">
                <X size={20} />
              </button>
            </div>
            <nav className="bo-mobile-sheet-nav">
              {navLinks.map(({ to, label, end }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={end}
                  className={({ isActive }) => `bo-mobile-nav-link${isActive ? ' active' : ''}`}
                  onClick={closeMenu}
                >
                  {label}
                </NavLink>
              ))}
            </nav>
            <div className="bo-mobile-sheet-footer">
              {user?.email && <span className="bo-mobile-sheet-email">{user.email}</span>}
              <Link to="/dashboard" className="bo-mobile-action-btn" onClick={closeMenu}>
                Normal View
              </Link>
              <button className="bo-mobile-action-btn danger" onClick={logout}>
                Log out
              </button>
            </div>
          </div>
        </>
      )}

      <main className="bo-main">
        <Outlet />
      </main>
    </div>
  );
}
